import { AnchorLink } from 'gatsby-plugin-anchor-links'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Layout from '../../components/Layout/Layout'
import styles from '../../style/training.module.css'


export default function research() {
    return (
        <Layout>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}>
                    
                    <h1 className="title"><span className="underline">ЭРЧИМ ХҮЧНИЙ СУДАЛГАА</span></h1>
                    <p>
                    Эрчим хүчний баланс боловсруулах, Эрчим хүчний хэмнэлтийн индикатор тодорхойлох, Хүламжийн хийн ялгарлыг бууруулах, Эрчим хүчний байрилга байгууламжийн төсөв боловсруулах, ТЭЗҮ боловсруулах гэх мэт олон төрлийн судалгаа шинжилгээг мэргэжлийн түвшинд гүйцэтгэнэ. Эрчим хүчний судалгаа,шинжилгээ хийх  
                    </p>
                    <h1>
                        Эрчим хүчний судалгаа хийлгэх процесс
                    </h1>
                    <div className={styles.image_container}>
                        <StaticImage src="../../images/research_process.JPG" alt="research" />
                    </div>
                    <p>
                        Танд эрчим хүчний хэмнэлт, үр ашиг, хүлэмжийн хийн ялгарлыг бууруулах чиглэлээр  судалгаа хийх, төсөл боловсруулах, ТЭЗҮ хийлгэх шаардлагатай байгаа бол <AnchorLink to="/#contact" className={styles.link}>энд</AnchorLink> дарж дэлгэрэнгүй мэдээлэл авна уу. 
                    </p>
                        <h1 className="title"><span className="underline">ХҮЛЭМЖИЙН ХИЙН ЯЛГАРЛЫГ БУУРУУЛАХ СУДАЛГАА</span></h1>
                        <i>НҮБ-ын санхүүжилтээр 2017-2020 онд хэрэгжсэн  “Барилгын салбарт хүлэмжийн хийн ялгарлыг бууруулах төсөл”-д би Бодлогын зөвлөхөөр ажилласан юм. Тус төсөлд би барилгын салбарт хүлэмжийн хийн тооллогын  систем болон хүлэмжийн хийн ялгарлыг бууруулах бүтэц  зохицуулалтыг тодорхойлох судалгаа хийж,  Барилга, Эрчим хүч, Байгаль орчны салбарын шийдвэр гаргагч нар,  хувийн хэвшлийн байгууллагуудын төлөөлөлд танилцуулан хэлэлцүүлэг өрнүүлж, дүгнэлт зөвлөмж гаргалаа. </i>
                        <div className={styles.course}>
                            <div>
                                <StaticImage src="../../images/Сургалт-7.JPG" alt="re" style={{maxWidth: '600px'}} className={styles.image}/>
                                
                            </div>
                            <div>
                                <ul>
                                    <li>
                                        <b>Сургалтын сэдэв: </b> ХҮЛЭМЖИЙН ХИЙН ТООЛЛОГЫН СИСТЕМИЙН БҮТЭЦ ЗОХИЦУУЛАЛТ
                                    </li>
                                    <li>
                                        <b>Огноо:</b>  2017 оны 11-р сараас 2019 оны 2-р сар
                                    </li>
                                    <li>
                                        <b>Сургалтанд хамрагдагсад: </b> Барилга, Эрчим хүч, Байгаль орчны салбарын шийдвэр гаргагч нар,  хувийн хэвшлийн байгууллагуудын төлөөлөл
                                    </li>
                                    <li>
                                        <b>Сургалт зохион байгуулсан газар: </b>БХБЯ-ны хурлын танхим
                                    </li>
                                    <li>
                                        <b>Сургалтын агуулга:</b> ЭБарилгын салбарт хүлэмжийн хийн тооллогын системийг бүрдүүлэх, салбар хоорондын уялдаа холбоог хэрхэн хангах, бүтэц зохицуулалтыг Уур амьсгалын суурь конвенцийн шаардлагад нийцүүлэн зохион байгуулах талаар тайлбарлана. 
                                    </li>
                                </ul>
                                <br/>

                            </div>
                        </div>
                        <hr/>
                        <div className={styles.course}>
                            <StaticImage src="../../images/Сургалт-6.JPG" alt="surgalt6" style={{maxWidth: '600px'}} className={styles.image}/>
                            <ul>
                                    <li>
                                        <b>Сургалтын сэдэв: </b> ХҮЛЭМЖИЙН ХИЙН ЯЛГАРЛЫГ БУУРУУЛАХ БҮТЭЦ ЗОХИЦУУЛАЛТ
                                    </li>
                                    <li>
                                        <b>Огноо:</b>  2017 оны 11-р сараас 2019 оны 2-р сар
                                    </li>
                                    <li>
                                        <b>Сургалтанд хамрагдагсад: </b> Барилга, Эрчим хүч, Байгаль орчны салбарын шийдвэр гаргагч нар,  хувийн хэвшлийн байгууллагуудын төлөөлөл
                                    </li>
                                    <li>
                                        <b>Сургалт зохион байгуулсан газар: </b>“Red rock” амралтын газрын хурлын танхим
                                    </li>
                                    <li>
                                        <b>Сургалтын агуулга:</b> Барилгын салбарт хүлэмжийн хийн ялгарлыг бууруулах системийг бүрдүүлэх, салбар хоорондын уялдаа холбоог хэрхэн хангах, бүтэц зохицуулалтыг Уур амьсгалын суурь конвенцийн шаардлагад нийцүүлэн зохион байгуулах талаар тайлбарлана.
                                    </li>
                                </ul>
                                
                            </div> 

                            <div className={styles.course}>
                                <div>
                                </div>

                            </div> 

                    </div>
                </div>
            </div>
        </Layout>
    )
}
